export default async function PerfGraficoRelatorio(
    h,
    mediaAgrupadorList,
    metaUsar,
    titulo,
    groupByConfig,
    apontamentos,
    paramsCliente,
    dataInicio,
    dataFim,
    primeiro
) {
    return [
        (primeiro ? "" : h.pageBreak({ pageOrientation: 'portrait' })),
        h.panel(
            [h.row(h.title(titulo, { fontSize: 12 }),),
            ],
            { widths: ["*"], unbreakable: true }
        ),
        h.tablePanel([
            { title: "Agrupador", value: groupByConfig.nome },
            { title: "Meta Cliente", value: '' },
            { title: "Data de Início", value: dataInicio },
            { title: "Data de Fim", value: dataFim },
        ]),
        h.panel(
            [
                h.row(
                    h.text(
                        parseFloat(mediaAgrupadorList[0].media).toFixed(0) + " un.",
                        { alignment: "center", fontSize: 40, }
                    )
                ),
            ],
            { widths: ["*"], unbreakable: true, layout: "borders" }
        ),
        h.tablePanel(
            [
                { title: groupByConfig.nome, field: "groupNameShow" },
                { title: "Média", field: "media" },
                { title: "Status", field: "status" },
            ],
            mediaAgrupadorList
        ),
    ]
}